import React, { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { Button, DatePicker } from 'antd';
import { ReceptionistCallsRange, getReceptionistCallsCustomRange } from '../types/ReceptionistCallDisplay';

interface ReceptionistCallsCustomRangeProps {
  range: ReceptionistCallsRange;
  onApply: (range: ReceptionistCallsRange) => void;
}

// The dates are only a draft until "Appliquer": no fetch on every date picked
const ReceptionistCallsCustomRange: React.FC<ReceptionistCallsCustomRangeProps> = ({ range, onApply }) => {
  const [start, setStart] = useState<Dayjs | null>(dayjs(range.start));
  const [end, setEnd] = useState<Dayjs | null>(dayjs(range.end));

  const isFuture = (date: Dayjs) => date.isAfter(dayjs(), 'day');
  const customRange = getReceptionistCallsCustomRange(start, end);

  return (
    <div className="receptionist-calls__custom-range">
      <span>Du</span>
      <DatePicker value={start} onChange={setStart} format="DD/MM/YYYY" allowClear={false} disabledDate={isFuture} />
      <span>Au</span>
      <DatePicker
        value={end}
        onChange={setEnd}
        format="DD/MM/YYYY"
        allowClear={false}
        disabledDate={(date) => isFuture(date) || (!!start && date.isBefore(start, 'day'))}
      />
      <Button type="primary" onClick={() => customRange && onApply(customRange)} disabled={!customRange}>
        Appliquer
      </Button>
    </div>
  );
};

export default ReceptionistCallsCustomRange;
